<template>
  <div class="leaflet-map">
    <l-map ref="map" style="height: 450px" :zoom="zoom" :center="center">
      <l-tile-layer :url="url"></l-tile-layer>
      <l-marker :lat-lng="markerLatLng">
        <l-popup content="Building location" />
      </l-marker>
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import { Icon } from "leaflet";

//fix for marker visibility
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  props: {
    latitude: Number,
    longitude: Number,
  },
  mounted() {
    setTimeout(() => {
      this.refreshMap();
    }, 500);
  },
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      zoom: 15,
      showMap: true,
    };
  },
  methods: {
    toggleShowMap: function () {
      this.showMap = !this.showMap;
    },
    refreshMap() {
      this.$refs.map.mapObject.invalidateSize();
    },
  },
  computed: {
    center: function () {
      return [this.latitude, this.longitude];
    },
    markerLatLng: function () {
      return [this.latitude, this.longitude];
    },
  },
};
</script>

<style scoped>
.leaflet-map {
  margin: 0 auto;
}
</style>
